
import {RenewInterval} from 'components/checkout/query/types';

export enum CheckoutReason {
	purchase = 'purchase',
	reserveAppt = 'reserveAppt',
}

export interface QueryVars {
	configs: {
		reason: CheckoutReason;
		redirect: string;
	}

	intent: string;
	provisional?: string

	// Must set one of: product OR appt
	appt?: string;
	hold?: string;
	product?: string;

	// Additional vars determine pricing
	quantity: number;
	interval?: RenewInterval;
	discount?: string;
	bbuxCents?: number;

	// Referral tracking
	referrer?: string;
}
